(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumari-hair-quiz"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.lq-wrap').forEach(initLumariQuiz);
});

function initLumariQuiz(root) {
  var steps = Array.prototype.slice.call(root.querySelectorAll('.lq-step'));
  var questionSteps = steps.filter(function (s) { return s.hasAttribute('data-question'); });
  var progressFill = root.querySelector('[data-lq-progress-fill]');
  var backBtn = root.querySelector('[data-lq-back]');
  var current = 0;
  var history = [0];

  function showStep(index) {
    steps.forEach(function (s, i) {
      s.classList.toggle('is-active', i === index);
    });
    var step = steps[index];
    var isQuestion = step.hasAttribute('data-question');
    var pct = (index / (steps.length - 1)) * 100;
    progressFill.style.width = pct + '%';
    backBtn.hidden = history.length <= 1 || !isQuestion;

    if (step.classList.contains('lq-loading')) {
      runLoadingSequence(step);
    }
    if (step.getAttribute('data-step') === '12') {
      renderGauge();
    }
  }

  function goTo(index) {
    current = index;
    history.push(index);
    showStep(current);
  }

  function goNext() {
    if (current < steps.length - 1) {
      goTo(current + 1);
    }
  }

  function goBack() {
    if (history.length > 1) {
      history.pop();
      current = history[history.length - 1];
      showStep(current);
    }
  }

  function syncOptionVisual(input) {
    var option = input.closest('.lq-option');
    if (option) {
      option.classList.toggle('is-checked', input.checked);
    }
  }

  // single-select: auto-advance
  root.querySelectorAll('input[type="radio"]').forEach(function (input) {
    input.addEventListener('change', function () {
      var group = input.name;
      root.querySelectorAll('input[name="' + group + '"]').forEach(syncOptionVisual);
      setTimeout(goNext, 250);
    });
  });

  // multi-select: toggle visual + enable continue button per step
  root.querySelectorAll('.lq-step[data-multi]').forEach(function (step) {
    var checkboxes = Array.prototype.slice.call(step.querySelectorAll('input[type="checkbox"]'));
    var continueBtn = step.querySelector('[data-lq-multi-continue]');
    checkboxes.forEach(function (box) {
      box.addEventListener('change', function () {
        syncOptionVisual(box);
        var anyChecked = checkboxes.some(function (b) { return b.checked; });
        if (continueBtn) {
          if (anyChecked) {
            continueBtn.removeAttribute('disabled');
          } else {
            continueBtn.setAttribute('disabled', 'disabled');
          }
        }
      });
    });
    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        if (!continueBtn.hasAttribute('disabled')) {
          goNext();
        }
      });
    }
  });

  root.querySelectorAll('[data-lq-continue]').forEach(function (btn) {
    btn.addEventListener('click', goNext);
  });

  root.querySelectorAll('[data-lq-skip]').forEach(function (btn) {
    btn.addEventListener('click', goNext);
  });

  backBtn.addEventListener('click', goBack);

  function getCheckedValues(selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector + ':checked'));
  }

  function getChecked(selector) {
    return root.querySelector(selector + ':checked');
  }

  function runLoadingSequence(step) {
    var items = Array.prototype.slice.call(step.querySelectorAll('[data-checklist-item]'));
    var i = 0;
    items.forEach(function (item) { item.classList.remove('is-active', 'is-done'); });
    items[0].classList.add('is-active');
    var interval = setInterval(function () {
      items[i].classList.remove('is-active');
      items[i].classList.add('is-done');
      i++;
      if (i >= items.length) {
        clearInterval(interval);
        setTimeout(goNext, 400);
        return;
      }
      items[i].classList.add('is-active');
    }, 850);
  }

  var hoogResult = {
    badge: 'Hoog', color: 'var(--lq-pink)', tint: '#fde8ef', score: 88,
    condition: 'Overactief', potential: 'Groot', confidence: 'Merkbaar', timeline: '4 weken'
  };

  function joinDutchList(items) {
    if (items.length === 0) return '';
    if (items.length === 1) return items[0];
    return items.slice(0, -1).join(', ') + ' en ' + items[items.length - 1];
  }

  function buildPersonalCopy() {
    var zoneLabels = getCheckedValues('[data-zone-group] input').map(function (i) { return i.value.toLowerCase(); });
    var reactionLabels = getCheckedValues('[data-reaction-group] input').map(function (i) { return i.value.toLowerCase(); });

    var sentence;
    if (zoneLabels.length) {
      sentence = 'Je gaf aan last te hebben van ongewenste haargroei rondom je ' + joinDutchList(zoneLabels) + '.';
    } else {
      sentence = 'Je gaf aan last te hebben van ongewenste haargroei op de zones die jij hebt aangegeven.';
    }

    if (reactionLabels.length) {
      sentence += ' Daarbij merk je regelmatig dat je last hebt van ' + joinDutchList(reactionLabels) + '.';
    }

    sentence += ' Dit wijst op een terugkerende cyclus in de haarfollikel: snel terugkerend haar en een routine die veel vraagt. Tijd om de haarfollikel zelf aan te pakken in plaats van steeds het topje.';
    return sentence;
  }

  function renderGauge() {
    var cfg = hoogResult;
    var badgeEl = root.querySelector('[data-gauge-badge]');
    var markerEl = root.querySelector('[data-gauge-marker]');
    var copyEl = root.querySelector('[data-gauge-copy]');
    var calloutEl = root.querySelector('[data-gauge-callout]');
    var calloutIconEl = root.querySelector('[data-gauge-callout-icon]');
    var calloutTitleEl = root.querySelector('[data-gauge-callout-title]');
    var conditionEl = root.querySelector('[data-stat-condition]');
    var potentialEl = root.querySelector('[data-stat-potential]');
    var confidenceEl = root.querySelector('[data-stat-confidence]');
    var timelineEl = root.querySelector('[data-stat-timeline]');

    if (badgeEl) {
      badgeEl.textContent = cfg.badge;
      badgeEl.style.background = cfg.color;
      badgeEl.style.color = '#fff';
    }
    if (markerEl) markerEl.style.left = cfg.score + '%';
    if (copyEl) copyEl.textContent = buildPersonalCopy();
    if (calloutEl) calloutEl.style.background = cfg.tint;
    if (calloutIconEl) calloutIconEl.style.background = cfg.color;
    if (calloutTitleEl) calloutTitleEl.textContent = cfg.badge + ' niveau';
    if (conditionEl) conditionEl.textContent = cfg.condition;
    if (potentialEl) potentialEl.textContent = cfg.potential;
    if (timelineEl) timelineEl.textContent = cfg.timeline;
    if (confidenceEl) confidenceEl.textContent = cfg.confidence;

    sendQuizAnalytics();
  }

  var analyticsSent = false;
  function sendQuizAnalytics() {
    if (analyticsSent) return;
    var url = root.getAttribute('data-analytics-url');
    if (!url) return;
    analyticsSent = true;

    function singleValue(selector) {
      var el = getChecked(selector);
      return el ? el.value : null;
    }
    function multiValues(selector) {
      return getCheckedValues(selector).map(function (i) { return i.value; });
    }

    var payload = {
      age: singleValue('input[name^="lq-age-"]'),
      zones: multiValues('[data-zone-group] input'),
      methods: multiValues('[data-method-group] input'),
      speed: singleValue('input[name^="lq-speed-"]'),
      struggles: multiValues('[data-struggle-group] input'),
      ethnicity: singleValue('input[name^="lq-ethnicity-"]'),
      skin_type: singleValue('input[name^="lq-skin-"]'),
      reactions: multiValues('[data-reaction-group] input'),
      hair_color: singleValue('input[name^="lq-color-"]'),
      submitted_at: new Date().toISOString(),
      page_url: window.location.href
    };

    try {
      fetch(url, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify(payload)
      });
    } catch (e) {}
  }

  showStep(0);
}

  } catch(e) { console.error(e); }
})();
})();
